export const blockElementSlots = [
  'box',
  'headerBox',
  'headerText',
  'contentBox',
  'contentElement',
];
